module.exports = __webpack_public_path__ + "img/banckg.0bc9e683.png";